import { lazy, Suspense } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { AuthProvider } from './context/AuthContext'
import { SiteConfigProvider, useSiteConfig } from './context/SiteConfigContext'
import Layout from './components/layout/Layout'
import PageLoader from './components/ui/PageLoader'

const Home           = lazy(() => import('./pages/Home'))
const About          = lazy(() => import('./pages/About'))
const Services       = lazy(() => import('./pages/Services'))
const Team           = lazy(() => import('./pages/Team'))
const Contact        = lazy(() => import('./pages/Contact'))
const Blog           = lazy(() => import('./pages/Blog'))
const BlogPost       = lazy(() => import('./pages/BlogPost'))
const Forum          = lazy(() => import('./pages/Forum'))
const Store          = lazy(() => import('./pages/Store'))
const FAQ            = lazy(() => import('./pages/FAQ'))
const Testimonials   = lazy(() => import('./pages/Testimonials'))
const Coverage       = lazy(() => import('./pages/Coverage'))
const PrivacyPolicy  = lazy(() => import('./pages/PrivacyPolicy'))
const TermsOfService = lazy(() => import('./pages/TermsOfService'))
const NotFound       = lazy(() => import('./pages/NotFound'))
const Downloadables  = lazy(() => import('./pages/Downloadables'))
const ComingSoon     = lazy(() => import('./pages/ComingSoon'))

// El panel de administración fue migrado al Backoffice unificado.
// /admin/login y /admin/* redirigen automáticamente al Backoffice.
const AdminLogin      = lazy(() => import('./pages/admin/Login'))
const AdminDeprecated = lazy(() => import('./pages/admin/Deprecated'))

// Wrapper que muestra ComingSoon cuando el modo está activo
function PublicWrapper({ children }) {
  const { siteConfig, loading } = useSiteConfig()
  if (loading) return <PageLoader />
  if (siteConfig.comingSoonEnabled) return <Suspense fallback={<PageLoader />}><ComingSoon /></Suspense>
  return children
}

function App() {
  return (
    <HelmetProvider>
    <SiteConfigProvider>
    <AuthProvider>
      <Router>
        <Suspense fallback={<PageLoader />}>
        <Routes>
          {/* Public Routes — interceptadas por PublicWrapper */}
          <Route element={<PublicWrapper><Layout /></PublicWrapper>}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/team" element={<Team />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/forum" element={<Forum />} />
            <Route path="/store" element={<Store />} />
            <Route path="/downloads" element={<Downloadables />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/coverage" element={<Coverage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="*" element={<NotFound />} />
          </Route>

          {/* Admin Login → redirige al Backoffice (legacy: mantiene URL conocida) */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Todo /admin/* fue migrado al Backoffice. Redirect automático. */}
          <Route path="/admin" element={<AdminDeprecated />} />
          <Route path="/admin/*" element={<AdminDeprecated />} />
        </Routes>
        </Suspense>
      </Router>
    </AuthProvider>
    </SiteConfigProvider>
    </HelmetProvider>
  )
}

export default App